import styled from 'styled-components';

export const RequiredFieldRow = styled.div<{ $noTopGap?: boolean }>`
  display: grid;
  grid-template-columns: 170px 240px auto;
  padding-top: ${({ $noTopGap }) => ($noTopGap ? 0 : '8px')};
`;

export const TemporalCellDiv = styled.div`
  display: flex;
  align-items: center;
`;

export const SubjectNameWrapperDiv = styled.div`
  max-width: 150px;
  display: flex;
  align-items: center;
`;

export const InstallTemporalsSectionDiv = styled.div`
  margin-top: 14px;
`;
